import React, { useState, useEffect } from 'react'
import { Box, Grid, Menu, MenuItem } from '@mui/material'
import { fetchData, deleteData } from '../../../../../pages/Utils/Baseurl';
import MaterialInput from '../../../../../components/MaterialInput'
import { useSnackbar } from '../../../../../components/SnackbarProvider';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import '../ActivePlans/index.css'
// import MaterialTypography from '../../../../../components/MaterialTypography';
import { useLoading } from '../../../../../context/loadingcontext';

const ClosedPlans = ({ selectedProject, onEdit, refreshTrigger }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [testPlanList, setTestPlanList] = useState([]);
  const [search, setSearch] = useState('');
  const { setCirleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const fetchTestPlans = React.useCallback(async () => {
    setCirleLoading(true);
    try {
      const response = await fetchData(`api/testplan/?project_id=${selectedProject.value}&flag=2`);
      if (response && response.status) {
        setTestPlanList(response.data);
      } else {
        setTestPlanList([]);
      }
    } catch (error) {
      console.error("Error fetching completed test plans:", error);
      setTestPlanList([]);
    } finally {
      setCirleLoading(false);
    }
  }, [selectedProject, setCirleLoading]);

  useEffect(() => {
    if (selectedProject?.value) {
      fetchTestPlans();
    }
  }, [selectedProject, fetchTestPlans, refreshTrigger]);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    if (!selectedRow) return;

    const confirmDelete = window.confirm("Are you sure you want to delete this test plan?");
    if (!confirmDelete) return;

    setCirleLoading(true);
    try {
      const response = await deleteData(`api/testplan/${selectedRow.id}/`);
      if (response) {
        showSnackbar('Test Plan deleted successfully', 'success');
        fetchTestPlans();
      }
    } catch (error) {
      console.error("Error deleting test plan:", error);
      showSnackbar(error.response?.data?.message || 'Failed to delete Test Plan', 'error');
    } finally {
      setCirleLoading(false);
      handleMenuClose();
    }
  };

  return (
    <Grid container spacing={2} direction='column' mt={1.5}>
      <Grid size={{ xs: 12 }} sx={{ paddding: 1.5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', paddingX: 1 }}>
          <MaterialInput
            label='Search the test plans here..'
            placeholder='Serach the test plans here..'
            size='small'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ maxWidth: '300px' }}
          />
        </Box>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <div className="table-container">
          <table className="custom-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>TITLE</th>
                <th>DURATION</th>
                <th>OWNER</th>
                <th>PROGRESS</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {testPlanList.map((row) => (
                <tr key={row.id} className="table-row">
                  <td className="id-cell">{row.plan_id}</td>
                  <td>
                    <div className="title">
                      <span className="title-text">{row.title}</span>
                      <span className="description">{row.status}</span>
                    </div>
                  </td>
                  <td>
                    <div className="duration">
                      <span>{row.duration}</span>
                    </div>
                  </td>
                  <td>
                    <span className="owner-name">{row.owner_name}</span>
                  </td>
                  <td>
                    <div className="progress-container">
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: `${row.progress}%`, backgroundColor: '#34d399' }}
                        ></div>
                      </div>
                      <span className="progress-text">{row.progress}%</span>
                    </div>
                  </td>
                  <td className="menu-cell">
                    <MoreVertIcon
                      className="menu-icon"
                      onClick={(e) => handleMenuOpen(e, row)}
                    />
                  </td>
                </tr>
              ))}
              {testPlanList.length === 0 && (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                    No completed test plans found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              style: { borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" },
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={() => {
              handleMenuClose();
              if (onEdit) onEdit(selectedRow);
            }}>Edit Test Plan</MenuItem>
            <MenuItem onClick={handleDelete} sx={{ color: "red", backgroundColor: "rgba(255, 0, 0, 0.1)" }}>Delete</MenuItem>
            <MenuItem onClick={handleMenuClose}>View Details</MenuItem>
          </Menu>
        </div>
      </Grid>
    </Grid>
  )
}

export default ClosedPlans
